var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c(_vm.datas.moduleStyleType == 1 ? 'detail1' : 'detail2',{ref:"detailComponent",tag:"component",attrs:{"datas":_vm.datas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }